import React from "react";
import { Button, Popover, Text } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller.js";
export const UnifiedPriceTagPriceBreakdownDesktop = ({ priceBreakdownTrigger, priceBreakdownTriggerProps, priceBreakdownContent, priceBreakdownOnOpen = () => { }, priceBreakdownOnClose = () => { }, priceBreakdownCloseAriaLabel }) => {
    const { contentTitle, showPriceBreakdown, setShowPriceBreakdown } = useUnifiedPriceTagPriceBreakdownController();
    if (!priceBreakdownTrigger || !priceBreakdownContent) {
        return;
    }
    return (React.createElement(Popover, { position: "bottom", active: showPriceBreakdown, onOpen: () => {
            setShowPriceBreakdown(true);
            priceBreakdownOnOpen();
        }, onClose: () => {
            setShowPriceBreakdown(false);
            priceBreakdownOnClose();
        }, closeAriaLabel: priceBreakdownCloseAriaLabel },
        React.createElement(Popover.Trigger, null, (attributes) => (React.createElement(Button, { variant: "tertiary-neutral", size: "medium", ...priceBreakdownTriggerProps, attributes: {
                ...priceBreakdownTriggerProps?.attributes,
                ...attributes
            } }, priceBreakdownTrigger))),
        React.createElement(Popover.Content, { title: React.createElement(Text, { variant: "headline_3", tagName: "h2" }, contentTitle), attributes: {
                style: { width: 360 },
                role: "dialog",
                "aria-modal": "true",
                "data-testid": "upt_price_breakdown_content"
            } }, priceBreakdownContent)));
};
